import React, {useRef} from 'react';
import print from "../../../../icons/print.png";
import {ExcelPrint, Pdf} from "../../../../components/functions/Print";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import {useReactToPrint} from "react-to-print";
import {monthDays} from "../../../../components/functions/Month";
import {NavLink} from "react-router-dom";
import {EditOutlined} from '@ant-design/icons'

function Manbalar({month, data}) {
    const conponentPDF= useRef();
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Userdata",
        onAfterPrint:()=>alert("Data saved in PDF")
    });
    return (
        <div className="table-box-con">
            <div className="table-content-top">
                <div className="table-top-left">
                    <NavLink to="/suvdanfoydalanish/edit" className="btn btn-outline-primary d-flex align-items-center p-2 btn-sm">Kiritish/o'zgartirish&nbsp;<EditOutlined /></NavLink>
                </div>
                <ul className="table-top-right">
                    <li>
                        <button className="btn p-0" onClick={() => generatePDF()}>
                            <img src={print} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button  onClick={() => Pdf('tblData')} className="btn p-0">
                            <img src={pdf} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={()=>ExcelPrint("Suvdan foydalanish", "sheet 1","tblData")}>
                            <img src={excel} alt="404"/>
                        </button>
                    </li>
                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <div ref={conponentPDF} style={{width:'100%'}}>
                    <table id="tblData" className="table table-bordered table-style">
                        <thead>
                        <tr>
                            <th rowSpan={2} scope="col">№</th>
                            <th rowSpan={2} scope="col">Manba nomi</th>
                            <th colSpan={monthDays(month)} scope="col">{month}</th>
                        </tr>
                        <tr>
                            {
                                Array(monthDays(month)).fill(1).map((i,d)=>{
                                    return <th key={d}>{d+1}</th>
                                })
                            }
                        </tr>
                        </thead>
                        {
                            data.length?
                                data.map((d,i)=>{
                                    return(
                                        <tbody key={i+"d"}>
                                            <tr>
                                                <td>{i+1}</td>
                                                <td className="text-start">{d.name}</td>
                                                {
                                                    Array(monthDays(month)).fill(1).map((k,i)=>{
                                                        return <td className="vertical-middle" key={i+'da'}>{d.data?d.data[i+1]?d.data[i+1]:'':''}</td>
                                                    })
                                                }
                                            </tr>
                                        </tbody>
                                    )
                                })
                                :null
                        }
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Manbalar;